import { api } from '@/scripts/api';

export const FundPoolsService = {
    getById(fundPoolId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/${fundPoolId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getAll(accountId, options = '') {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/account/${accountId}?${options}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    post(payload, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/account/${accountId}`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    put(id, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/${id}/account/${accountId}`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/${id}/account/${accountId}`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },
}
